export default function isValidDnsName(value) {
  return /^[a-zA-Z0-9-]+$/.test(value);
}
